import * as React from "react";
import { intakeWizardStrings } from "./intakeWizard";
import { learnStrings, readLearnLocaleOverride } from "./learn";
import { portalShellStrings, type PortalLocale } from "./portalShell";
import { studyGroupChatStrings } from "./studyGroupChat";

/**
 * drei's `<Html>` mounts checkpoint cards in a second React root, so they
 * cannot see the app QueryClient. The portal locale hook publishes here, and
 * the cards subscribe without calling `useQueryClient`.
 */
function mergeStrings(locale: PortalLocale) {
  return {
    ...portalShellStrings(locale),
    ...learnStrings(locale),
    ...intakeWizardStrings(locale),
    ...studyGroupChatStrings(locale),
  };
}

let current: PortalLocale = readLearnLocaleOverride() ?? "en";
const listeners = new Set<() => void>();

export function publishLearnLocale(locale: PortalLocale): void {
  if (locale === current) return;
  current = locale;
  for (const listener of listeners) listener();
}

export function useCanvasLearnStrings() {
  const locale = React.useSyncExternalStore(
    (onStoreChange) => {
      listeners.add(onStoreChange);
      return () => listeners.delete(onStoreChange);
    },
    () => current,
    () => "en" as PortalLocale,
  );
  return mergeStrings(locale);
}
